interface Props {
  width?: number;
  height?: number;
}

const HandHeldTabletWriting = ({ width = 16, height = 16 }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2196_36519)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.13352 0.107143C1.05471 0.107143 0.231934 1.00462 0.231934 2.04671V13.9533C0.231934 14.9954 1.05471 15.8928 2.13352 15.8928H11.5335C12.6124 15.8928 13.4351 14.9954 13.4351 13.9533V2.10714C13.4351 1.00257 12.5397 0.107143 11.4351 0.107143H2.13352Z"
          fill="#DFE1E2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.08912 11.7143H0.231934L0.231972 12.5714L0.232034 13.9533C0.232055 14.9953 1.05482 15.8928 2.13362 15.8928H11.5336C12.6125 15.8928 13.4352 14.9954 13.4352 13.9533L13.4351 12.5714V11.7143H12.578H1.08912Z"
          fill="#2F9E44"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.23186 3.4368C2.83738 3.4368 2.51758 3.7566 2.51758 4.15109C2.51758 4.54558 2.83738 4.86537 3.23186 4.86537H6.08362C6.47812 4.86537 6.79791 4.54558 6.79791 4.15109C6.79791 3.7566 6.47812 3.4368 6.08362 3.4368H3.23186ZM3.23186 6.71429C2.83738 6.71429 2.51758 7.03408 2.51758 7.42857C2.51758 7.82306 2.83738 8.14286 3.23186 8.14286H4.65775C5.05224 8.14286 5.37204 7.82306 5.37204 7.42857C5.37204 7.03408 5.05224 6.71429 4.65775 6.71429H3.23186Z"
          fill="#2F9E44"
        />
        <path
          d="M10.7449 8.45062C10.6623 8.53358 10.5563 8.58918 10.4411 8.60991L7.98586 9.05184C7.59741 9.12176 7.25672 8.78618 7.32078 8.39672L7.73093 5.90301C7.7504 5.78462 7.80664 5.67537 7.89168 5.59073L12.5951 0.909485C12.7014 0.802367 12.8278 0.717346 12.967 0.659324C13.1063 0.601302 13.2557 0.57143 13.4066 0.57143C13.5574 0.57143 13.7068 0.601302 13.8461 0.659324C13.9854 0.717346 14.1118 0.802367 14.218 0.909485L15.4294 2.12092C15.5365 2.22716 15.6215 2.35356 15.6796 2.49282C15.7377 2.63209 15.7675 2.78148 15.7675 2.93234C15.7675 3.08321 15.7377 3.2326 15.6796 3.37185C15.6215 3.51112 15.5365 3.63753 15.4294 3.74377L10.7449 8.45062Z"
          fill="#2F9E44"
        />
      </g>
      <defs>
        <clipPath id="clip0_2196_36519">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default HandHeldTabletWriting;
